import React from 'react';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';
import TermsSection from './TermsSection';
import { useNavigate } from 'react-router-dom';
import SEO from '../../components/common/SEO';

const GeneralTerms2 = () => {
  const navigate = useNavigate();

  const handlePrevious = () => {
    navigate('/general-terms/page/1');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleNext = () => {
    navigate('/general-terms/page/3');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const conditionGeneralList2 = [
    {
      title: 'Transport Risks',
      para: "Products are delivered either prepaid or cash-on-delivery to the agreed location. In all cases, they travel at the recipient's risk. In the event of damage or missing items, the recipient must make all necessary observations and confirm their reservations with the carrier by official act or registered letter with acknowledgment of receipt within three days of delivery.",
    },
    {
      title: 'Receipt',
      para: 'Without prejudice to actions against the carrier, written claims concerning visible defects or product discrepancies must be made within eight days of delivery. We do not guarantee defects or non-conformities not reported under these conditions. In such cases, we may replace or refund the product, excluding any further compensation.',
    },
    {
      title: 'Retention of Title',
      para: 'Products remain the exclusive property of ELIXIR until full payment has been received.',
    },
    {
      title: 'License',
      para: 'The use of our honey products is subject to these terms and conditions. No additional intellectual property rights are transferred to the client under these terms.',
    },
    {
      title: 'Warranty',
      para: 'We guarantee only that our honey products conform to their product descriptions. We do not guarantee any commercial benefit. Products are warranted against material or manufacturing defects that render them unfit for their intended use for a period of 30 days from delivery. Warranty claims must be made in writing within 7 days of discovering a defect. The warranty includes labor costs and covers repair or replacement only. It excludes cases of misuse, negligence, normal wear, force majeure, and failure to comply with our instructions.',
    },
    {
      title: 'Exclusion of Warranty',
      para: "All other warranties are excluded, particularly concerning suitability, reliability, availability, speed, security, accuracy, or completeness of the honey products. To the extent permitted by law, the products are provided 'as is' without any warranties or conditions, including implied warranties of merchantability, fitness for a particular purpose, title, or non-infringement. We do not guarantee uninterrupted or error-free operation, nor compatibility with unapproved configurations.",
    },
    {
      title: 'Intellectual Property',
      para: 'These GTC do not involve any transfer of intellectual property rights to the client. The client may not transfer or disclose any information or reproduce products without our consent.',
    },
    {
      title: 'Warranty Against Eviction',
      para: 'We only warrant against infringement arising from our own actions. If the client faces such a claim, they must notify us within 15 days, call us as guarantor, and cooperate fully. We will defend and, if necessary, compensate the client unless the infringement is due to unauthorized use, changes, or failure to follow our advice.',
    },
    {
      title: 'Subcontracting',
      para: 'We reserve the right to subcontract all or part of the services covered by these terms, provided that we remain responsible for their proper execution.',
    },
    {
      title: 'Force Majeure',
      para: 'Neither party shall be liable for any delay or failure to perform its obligations under these terms due to circumstances beyond its reasonable control, including but not limited to natural disasters, government actions, labor disputes, or other unforeseeable events.',
    },
    {
      title: 'Liability',
      para: 'The contract reflects the balance of economic interests and risk distribution agreed by the parties. We are bound only to a best-effort obligation, not to a guaranteed result.',
    },
    {
      title: 'Limitation of Liability',
      para: 'Our liability is limited to proven fault that has caused direct and foreseeable damage.',
    },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title="General Terms and Conditions - Page 2"
        description="Continued terms and conditions for Elixir honey products. Learn about transport risks, warranties, intellectual property, and liability limitations."
        keywords="Elixir warranty terms, honey transport risks, honey product warranty, Elixir liability terms, honey intellectual property"
      />
      <Header />
      <div className="bg-[#f7fbff] py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-3xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold text-[#d4af37] mb-6">
            GENERAL TERMS AND CONDITIONS
          </h1>
          <p className="text-base sm:text-base md:text-xl lg:text-2xl text-[#475467] max-w-3xl mx-auto">
            This section covers the terms related to product delivery, risks during transport,
            warranties, and intellectual property rights to ensure transparency and trust.
          </p>
        </div>
      </div>

      <main className="flex-grow bg-white py-16">
        <div className="container mx-auto px-4 max-w-3xl">
          {/* Summary/FAQ Section */}
          <section className="mb-8 bg-[#f7fbff] rounded-xl shadow p-6">
            <h2 className="text-xl font-semibold text-[#d4af37] mb-2">Quick Summary & FAQ</h2>
            <ul className="text-[#475467] text-base space-y-2">
              <li><b>Who is responsible for transport risks?</b> – The recipient bears the risk during transport. Please check your delivery upon arrival.</li>
              <li><b>What is the warranty period?</b> – Our honey products are warranted for 30 days against material or manufacturing defects.</li>
              <li><b>How do I report a defect?</b> – Contact us in writing within 7 days of discovering a defect.</li>
              <li><b>Are intellectual property rights transferred?</b> – No, all rights remain with Elixir.</li>
            </ul>
          </section>
          <TermsSection>
            {conditionGeneralList2.map((item, index) => (
              <p className="mt-4" key={index}>
                <b>{item.title} : </b>
                {item.para}
              </p>
            ))}
          </TermsSection>
          <div className="flex justify-center space-x-4 mt-4">
            <button
              onClick={handlePrevious}
              className="px-6 py-2 bg-[#d4af37] text-black rounded-md hover:bg-yellow-400 transition font-semibold"
            >
              Previous Page
            </button>
            <button
              onClick={handleNext}
              className="px-6 py-2 bg-[#d4af37] text-black rounded-md hover:bg-yellow-400 transition font-semibold"
            >
              Next Page
            </button>
          </div>
          {/* Internal Links Section */}
          <section className="mt-8 text-center">
            <div className="flex flex-wrap justify-center gap-4 mt-4">
              <a href="/general-terms/page/1" className="text-[#d4af37] underline hover:text-yellow-600">General Terms Page 1</a>
              <a href="/general-terms/page/3" className="text-[#d4af37] underline hover:text-yellow-600">General Terms Page 3</a>
              <a href="/contact" className="text-[#d4af37] underline hover:text-yellow-600">Contact Us</a>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default GeneralTerms2;
